export default __webpack_public_path__ + "static/media/icon_name.fc1b99e5.svg";